import { ActionTypes } from "../constants/action-types"

const initialState = {
  programCourseFilesById: []
}

const FetchProgramCourseFiles = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.FETCH_PROGRAM_COURSE_BY_ID : return {...state, 
            programCourseFilesById: payload}           
        default: return state;
    }
    
}


export default FetchProgramCourseFiles;